import list_icon from '@/assets/img/device/mg68/list_icon_pro_max.png'
import { Mg68ACE } from './mg68_ace'
import { KK } from '@/define/define'

export class Mg68ACE_W extends Mg68ACE {
  name: string = 'MG68_ACE_W'
  icon: string = list_icon
  width: number = 710
  fnDisableKeys: KK[] = [0x1, 0x8, 0xe, 0x14, 0x3d, 0x43, 0x49, 0x4f, 0x55, 0x57, 0x58, 0x59, 0x53, 0x4d, 0x52, 0x41, 0xb, 0x10, 0x16, 0x1c, 0x22, 0x44, 0x4a, 0x26]
  sleepTimeValues = [0, 30, 2 * 60, 3 * 60, 5 * 60, 15 * 60, 30 * 60, 1 * 60 * 60, 2 * 60 * 60, 4 * 60 * 60, 8 * 60 * 60, 12 * 60 * 60, 18 * 60 * 60]
  sleepTimeBTValues = this.sleepTimeValues
}
